module.exports = __webpack_public_path__ + "img/video-cover.0d7e6eb9.jpg";